<template>
  <div>
    <Header :ifbluene="ifbluene"></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box" style="overflow: hidden">
      <div class="main-item">
        <div class="body-left">
          <div class="test-box">
            <div class="test-head">
              <span class="test-title">学会新闻</span>
            </div>
            <ul class="test-ul">
              <item-news v-for="(n, index) in news" :key="index" :create_time="n.create_time" :title="n.title"
                :articleId="n.id" :tabName="topName"></item-news>
            </ul>
            <!-- <div class="test-btns">
              <input class="btn" type="button" value="<<" @click="previousPage"/>
              <input class="btn" type="button" v-for="(value, index) in pageSum" :key="index" :value="value" @click="witchPage">
              <input class="btn" type="button" value="..." v-show="pageSum === 11">
              <input class="btn" type="button" value=">>" @click="nextPage"/>
            </div> -->

            <div class="test-btns" style="position:relative" v-show="this.pageSum > 1 ? true : false">
              <input class="btn" type="button" value="<<" @click="previousPage" />
              <input class="btn" type="button" v-for="(value, index) in pageShow" :key="index" :value="value"
                @click="witchPage" :style="page == value ? 'background:#0064e8;color:#fff' : ''">
              <input class="btn" type="button" value=">>" @click="nextPage" />
              <div style="position:absolute;right:0;top:0">
                <input class="btn" style="border: 1px solid #d7d7d7;height: 26px;width: 60px;" type="number"
                  v-model.number="pageJumpNum" @keyup.enter="jumpPage" />
                <input class="btn" type="button" value="跳转" @click="jumpPage" />
              </div>
            </div>

          </div>
        </div>
        <!--<div class="body-right">
          <contact></contact>
        </div>-->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import contact from '@/components/contact/contact.vue'
import itemNews from '@/components/item/itemNews.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'news',
  data() {
    return {
      // 所在页面的名称
      topName: 'news',
      // 顶部导航栏
      ifbluene: {
        color: '#0051bd'
      },
      // 面包屑导航栏
      secondhref: '/news',
      secondtest: '学会新闻',
      // 总页数
      pageSum: 1,
      // 当前所在页面
      page: 1,
      // 新闻列表
      news: []
    }
  },
  mounted() {
    // 调用本页接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName).then(res => {
      this.news = res.data
      this.pageSum = Math.ceil(res.total / res.page_limit)
      if (this.pageSum > 9) {
        this.pageShow = [1, 2, 3, 4, 5, 6, 7, 8, 9, '...', this.pageSum]
      } else {
        this.pageShow = this.pageSum
      }
    })
  },
  components: {
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    contact: contact,
    itemNews: itemNews
  },
  methods: {
    jumpPage() {
      if (this.pageJumpNum >= 1 && this.pageJumpNum <= this.pageSum) {
        this.page = this.pageJumpNum
        HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
          this.news = res.data
        })
        if (this.pageSum > 9) {
          if (this.page <= 9) {
            this.pageShow = [1, 2, 3, 4, 5, 6, 7, 8, 9, '...', this.pageSum]
          } else if (this.page > 9 && this.page <= this.pageSum - 9) {
            this.pageShow = [this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page, this.page + 1, this.page + 2, this.page + 3, this.page + 4, '...', this.pageSum]
          } else if (this.page > this.pageSum - 9) {
            this.pageShow = [1, '...', this.page - 8, this.page - 7, this.page - 6, this.page - 5, this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page]
          }
        }
      }
    },
    previousPage: function () {
      // if (this.page !== 1) {
      //   this.page--
      // }
      // HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
      //   this.news = res.data
      // })

      if (this.page !== 1) {
        this.page--
        if (this.pageSum > 9) {
          if (this.page > 8 && this.page <= this.pageSum - 8) {
            this.pageShow = [this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page, this.page + 1, this.page + 2, this.page + 3, this.page + 4, '...', this.pageSum]
          } else if (this.page > 9 && this.page > this.pageSum - 8) {
            this.pageShow = [1, '...', this.page - 8, this.page - 7, this.page - 6, this.page - 5, this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page]
          } else {
            this.pageShow = [1, 2, 3, 4, 5, 6, 7, 8, 9, '...', this.pageSum]
          }
        }
      }
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
        this.news = res.data
      })


    },
    nextPage: function () {
      // if (this.page <= this.pageSum - 1) {
      //   this.page++
      // }
      // HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
      //   this.news = res.data
      // })

      if (this.page <= this.pageSum - 1) {
        this.page++
        if (this.pageSum > 9) {
          if (this.page > 9 && this.page <= this.pageSum - 8) {
            this.pageShow = [this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page, this.page + 1, this.page + 2, this.page + 3, this.page + 4, '...', this.pageSum]
          } else if (this.page > 9 && this.page > this.pageSum - 9) {
            this.pageShow = [1, '...', this.page - 8, this.page - 7, this.page - 6, this.page - 5, this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page]
          }
        }
      }
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
        this.news = res.data
      })
    },
    witchPage(event) {
      this.page = event.target.value
      if (this.page !== '...') {
        HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&page=' + this.page).then(res => {
          this.news = res.data
        })
      }
      if (this.pageSum > 9) {
        if (this.page == this.pageSum) {
          this.pageShow = [1, '...', this.page - 8, this.page - 7, this.page - 6, this.page - 5, this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page]
        } else if (this.page == 1) {
          this.pageShow = [1, 2, 3, 4, 5, 6, 7, 8, 9, '...', this.pageSum]
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import '../../node_modules/bootstrap/dist/css/bootstrap.css';
@import 'joinprocess/main.css';

.body-box {
  margin-top: 10px;
  background-color: #f5f5f5;
  min-height: 600px;
}

.body-left {
  width: 950px;
  float: left;
}

.body-right {
  width: 200px;
  float: right;
}

.test-box {
  padding: 12px;
  background-color: #ffffff;
  font-size: 12px;
  text-align: left;
  padding-bottom: 30px;
}

.test-head {
  height: 30px;
  margin-bottom: 15px;
  border-bottom: 1px solid #d7d7d7;
}

.test-title {
  font-size: 14px
}

.test-ul {
  list-style: none;
  margin-left: 0px
}

.test-btns {
  width: 100%;
  height: 30px;
  text-align: center;
  margin-top: 30px;
}

.test-btns input {
  padding: 0px 8px;
  margin: 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue